import { Box } from "@mui/material";
import React from "react";
import styles from "./buttonSection.module.scss";
import TabButtonGroup from "../../../../components/tabButtonGroup/TabButtonGroup";
import Button from "../../../../components/buttons/Buttons";
import PropTypes from "prop-types";

const ButtonSection = (props) => {
  const { handleAddVehicleClick, buttonList } = props;

  return (
    <Box className={styles.buttonGroupWrapper} data-testid="button-section">
      <TabButtonGroup
        buttonList={buttonList}
        handleTabClick={(value) => {}}
        withIcon={true}
        showCountSection={true}
        selectedTab={0}
      />

      <Box className={"actionButtonWrapper"}>
        <Button
          title="Add new vehicle"
          iconStyle={styles.plusIcon}
          buttonType="muibtn-primary-with-icon"
          withIcon={true}
          handleClick={handleAddVehicleClick}
        />
      </Box>
    </Box>
  );
};
export default ButtonSection;
ButtonSection.propTypes = {
  handleAddVehicleClick: PropTypes.any,
  buttonList: PropTypes.any,
};
